import { render, staticRenderFns } from "./PishkhanNetPa.vue?vue&type=template&id=420dacad&"
import script from "./PishkhanNetPa.vue?vue&type=script&lang=js&"
export * from "./PishkhanNetPa.vue?vue&type=script&lang=js&"
import style0 from "./PishkhanNetPa.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PishkhanNetPa.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports